import { Heading } from '@/src/tailwindui/heading';
import CreateEventStepOne from './CreateEventStepOne';
import { cn } from '@/src/lib/utils';
import clickerboothLogo from '../../clickerbooth_logo.png';
import romrLogo from '../../romr_logo.png';
import useCreateFirstEvent from '@/src/Events/components/hooks/useCreateFirstEvent';
import { useNavigate } from 'react-router-dom';

export default function CreateFirstEvent() {
    const navigate = useNavigate();
    const {
        platform,
        setPlatform,
        experience,
        setExperience,
        experienceTemplates,
        recordValues,
        saveEvent,
        processingFlowTemplates,
        templateValues,
        setTemplateValues,
        processingFlowTemplate,
        setProcessingFlowTemplate,
        eventName,
        setEventName,
    } = useCreateFirstEvent();

    return (
        <div className="mx-auto max-w-2xl px-4 py-4">
            <div className="flex flex-col justify-center gap-4 w-full">
                <div
                    className={cn(
                        'transition-all duration-300',
                        platform !== null && 'opacity-0 h-0 hidden',
                    )}
                >
                    <div className="flex justify-center items-center my-12">
                        <Heading className="text-3xl plex-sans">
                            Choose your experience
                        </Heading>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 items-center md:items-end justify-between gap-4 mx-8">
                        <div
                            className="border-2 border-gray-200 rounded-lg p-4 flex justify-center items-center hover:bg-gray-100 transition-all duration-300 cursor-pointer"
                            onClick={() => setPlatform('clickerbooth')}
                        >
                            <img
                                src={clickerboothLogo}
                                aria-label="clickerbooth"
                                className="h-32px clickable cursor-pointer object-contain pe-logo"
                            />
                        </div>
                        <div
                            className="border-2 border-gray-200 rounded-lg p-4 flex justify-center items-center hover:bg-gray-100 transition-all duration-300 cursor-pointer"
                            onClick={() => setPlatform('romr')}
                        >
                            <img
                                src={romrLogo}
                                aria-label="romr"
                                className="h-28px clickable cursor-pointer object-contain pe-logo"
                            />
                        </div>
                    </div>
                </div>
                <div
                    className={cn(
                        'flex flex-wrap items-end justify-between gap-4 transition-all duration-300',
                        platform === null && 'hidden opacity-0',
                    )}
                >
                    <div>
                        <Heading className="text-3xl plex-sans">
                            Create your first event
                        </Heading>
                    </div>
                </div>
                <div
                    className={cn(
                        'transition-all duration-300 opacity-100',
                        platform === null && 'opacity-0 hidden',
                    )}
                >
                    <div className="my-7" />

                    <div className="my-10 mt-6" />
                    <CreateEventStepOne
                        recordValues={recordValues}
                        eventName={eventName}
                        setEventName={setEventName}
                        processingFlowTemplate={processingFlowTemplate}
                        setProcessingFlowTemplate={setProcessingFlowTemplate}
                        processingFlowTemplates={processingFlowTemplates}
                        templateValues={templateValues}
                        setTemplateValues={setTemplateValues}
                        experienceTemplates={experienceTemplates}
                        experience={experience}
                        setExperience={setExperience}
                        platform={platform}
                        onNext={async () => {
                            await saveEvent();
                            if (platform === 'clickerbooth') {
                                navigate('/download/clickerbooth');
                            } else {
                                navigate('/download/romr');
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
